import { get, writable } from 'svelte/store'

import { goto } from '$app/navigation'
// import { goto } from '$app/navigation'
import { resetClient } from '$lib/stores/client'
// import { openai_visible_store } from '$lib/stores/openai/openai'
import { buildUrl, editEstimateUrl, editInvoiceUrl } from '$lib/urls'

import { gotoNavMainLocation } from './navigation/navigation'

export const menu_store = writable({ option: 'home' })

export const menu_manager = {
	getCurrentOption: function () {
		return _getMenuOption()
	},

	setCurrentOptionFromPageUrl: function (pageUrl: URL) {
		// console.log('menu - setOptionForCurrentPage - 00', pageUrl)

		const path = pageUrl.pathname
		let pageOption = null
		if (path.includes('/bo/settings')) pageOption = 'bo_settings'
		else if (path.includes('/bo/subscription')) pageOption = 'bo_subscription'
		else if (path.includes('/bo/logs')) pageOption = 'bo_logs'
		else if (path.includes('/bo/pdf2data')) pageOption = 'bo_pdf2data'
		else if (path.includes('/bo/monitor')) pageOption = 'bo_monitor'
		else if (path.includes('/bo/intercom')) pageOption = 'bo_intercom'

		else if (path.includes('/bo/openai')) pageOption = 'bo_openai'

		else if (path.includes('/invoices/new')) pageOption = 'invoice_new'
		else if (path.includes('/invoices/templates')) pageOption = 'invoices_templates'
		else if (path.includes('/invoices')) pageOption = 'invoices'
		else if (path.includes('/estimates/new')) pageOption = 'estimate_new'
		else if (path.includes('/estimates/templates')) pageOption = 'estimates_templates'
		else if (path.includes('/estimates')) pageOption = 'estimates'
		else if (path.includes('/clients/new')) pageOption = 'client_new'
		else if (path.includes('/clients')) pageOption = 'clients'
		else if (path.includes('/clientShippingLocations')) pageOption = 'clients'
		else if (path.includes('/settings/invoice/branding')) pageOption = 'settings_invoice_branding'
		// else if (path.includes("/items/new"))
		//     pageOption = "item_new"
		else if (path.includes('/items')) pageOption = 'items'
		else if (path.includes('/taxes')) pageOption = 'taxes'
		else if (path.includes('/categories')) pageOption = 'categories'
		else if (path.includes('/expenses_categories')) pageOption = 'expenses_categories'
		else if (path.includes('/expenses')) pageOption = 'expenses'
		else if (path.includes('/openai')) pageOption = 'openai'
		else if (path.includes('/settings')) pageOption = 'settings'
		else if (path.includes('/users')) pageOption = 'users'
		else if (path === '/') pageOption = 'home'

		const currentMenuOption = _getMenuOption()

		if (pageOption !== null && pageOption !== currentMenuOption) {
			__setMenuOption(pageOption)
		}
	},

	goOption: function (option: string, route: string) {
		menu_gotoAndSetNavLocation(route)
	},

	//------------------
	//--- BackOffice
	goBoSettings: function () {
		menu_gotoAndSetNavLocation('/bo/settings')
	},
	goBoSubscription: function () {
		menu_gotoAndSetNavLocation('/bo/subscription')
	},
	goBoLogs: function () {
		menu_gotoAndSetNavLocation('/bo/logs')
	},
	goBoPdf2Data: function () {
		menu_gotoAndSetNavLocation('/bo/pdf2data')
	},
	goBoMonitor: function () {
		menu_gotoAndSetNavLocation('/bo/monitor')
	},
	goBoIntercom: function () {
		menu_gotoAndSetNavLocation('/bo/intercom')
	},
	goBoOpenAI: function () {
		menu_gotoAndSetNavLocation('/bo/openai')
	},
	
	//------------------
	//--- Dashboard
	goDashboard: function () {
		menu_gotoAndSetNavLocation('/')
	},
	//------------------

	//------------------
	//--- Invoices
	goListInvoicesItem: function (itemId: string) {
		menu_gotoAndSetNavLocation(`/invoices/item/${itemId}`)
	},
	goListInvoices: function (clientId?: string | null) {
		if (typeof clientId !== 'undefined') {
			menu_gotoAndSetNavLocation('/invoices/client/' + clientId)
		} else {
			menu_gotoAndSetNavLocation('/invoices')
		}
	},
	goNewInvoice: function (options?: NewInvoiceType) {
		let url = '/invoices/new'
		if (typeof options !== 'undefined') {
			url = buildUrl(url, options)
		}
		menu_gotoAndSetNavLocation(url)
	},
	goEditInvoice: function (invoiceId: string) {
		menu_gotoAndSetNavLocation(editInvoiceUrl(invoiceId))
	},
	goInvTemplate: function () {
		menu_gotoAndSetNavLocation('/invoices/templates')
	},
	//------------------

	//------------------
	//--- Estimates
	goListEstimatesItem: function (itemId: string) {
		menu_gotoAndSetNavLocation(`/estimates/item/${itemId}`)
	},
	goListEstimates: function (clientId?: string | null) {
		// _setMenuOption("estimates")
		if (typeof clientId !== 'undefined') {
			menu_gotoAndSetNavLocation('/estimates/client/' + clientId)
		} else {
			menu_gotoAndSetNavLocation('/estimates')
		}
	},
	//goNewEstimate: function (clientId?: string | null) {
	goNewEstimate: function (options?: NewEstimateType) {
		let url = '/estimates/new'
		if (typeof options !== 'undefined') {
			url = buildUrl(url, options)
		}
		menu_gotoAndSetNavLocation(url)
	},
	goEditEstimate: function (estimateId: string) {
		menu_gotoAndSetNavLocation(editEstimateUrl(estimateId))
	},
	goEstTemplate: function () {
		menu_gotoAndSetNavLocation('/estimates/templates')
	},
	//------------------

	//------------------
	//--- Expenses
	goListExpenses: function () {
		menu_gotoAndSetNavLocation('/expenses')
	},
	goListExpensesCategories: function () {
		menu_gotoAndSetNavLocation('/expenses_categories')
	},
	goNewExpenseCategory: function () {
		menu_goto('/expenses_categories/new')
	},

	//------------------
	//--- Clients
	goListClients: function () {
		menu_gotoAndSetNavLocation('/clients')
	},
	goNewClient: function () {
		resetClient()
		menu_gotoAndSetNavLocation('/clients/new')
	},
	goEditClient: function (clientId: string) {
		menu_gotoAndSetNavLocation(editEstimateUrl(clientId))
	},
	// goListClientShippingLocations: function (clientId: string) {
	// 	if (!clientId) return
	// 	menu_goto('/estimates/client/' + clientId)
	// },
	//------------------

	//------------------
	//--- Items
	goListItems: function () {
		menu_gotoAndSetNavLocation('/items')
	},
	goNewItem: function () {
		menu_goto('/items/new')
	},

	goListTaxes: function () {
		menu_gotoAndSetNavLocation('/taxes')
	},
	goNewTax: function () {
		menu_goto('/taxes/new')
	},

	goListCategories: function () {
		menu_gotoAndSetNavLocation('/categories')
	},
	goNewCategory: function () {
		menu_goto('/categories/new')
	},

	goUsers: function () {
		menu_gotoAndSetNavLocation('/users')
	},

	// goEditItem : function (itemId: string) {
	//     menu_goto(editItemUrl(itemId))
	// },
	//------------------

	// goOpenAI: function () {
	// 	//menu_gotoAndSetNavLocation('/openai')
	// 	$openai_visible_store = !$openai_visible_store
	// },
}

function menu_gotoAndSetNavLocation(location: string)
{
	gotoNavMainLocation(location)
}

function menu_goto(location: string)
{
	goto(location)
}

// function _setMenuOption(selOption: string) {
// }

function __setMenuOption(selOption: string) {
	menu_store.set({ option: selOption })
}

function _getMenuOption() {
	const selOption = get(menu_store).option
	return selOption
}

type NewInvoiceType = {
	clientId?: string
	itemId?: string
}

type NewEstimateType = {
	clientId?: string
	itemId?: string
}
